import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { ReactComponent as EdePirce } from "src/assets/images/edepirce.svg";
import { useSelector } from "react-redux";
import { formatAmount2 } from "src/helpers/Helpers";
const MyBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 14px;
`;
const EdePrice = () => {
  const edePrice = useSelector((state: any) => {
    return state.app.edePrice || 0;
  });
  return (
    <MyBox className="font-weight-6  color4">
      <EdePirce />${formatAmount2(edePrice, 2, true)}
    </MyBox>
  );
};

export default EdePrice;
